module.exports = "/static/img/project_detail.png?b55ffa3e1a312f7f1fbcef91c72ab9b5";